import { FormGroup, FormControlLabel, Checkbox } from "@mui/material";
import { Controller, UseFormReturn } from "react-hook-form";

/**
 * DefaultFormCheckBox
 */

type Props<T extends {}> = {
  name: keyof T;
  label?: string;
  readonly?: boolean;
  required?: boolean;
  disabled?: boolean;
  reactHookForm: UseFormReturn<T>;
  onChangeValue?: (value: boolean) => void;
};

export const DefaultFormCheckBox = <T extends {},>({
  name,
  label,
  readonly,
  required,
  disabled,
  reactHookForm,
  onChangeValue,
}: Props<T>) => {
  return (
    <Controller
      name={name as any}
      control={reactHookForm.control}
      render={({ field: { value, onChange } }) => {
        return (
          <FormGroup>
            <FormControlLabel
              label={label}
              required={required}
              disabled={disabled}
              className="text-sm text-black dark:text-white"
              control={
                <Checkbox
                  checked={value as any}
                  onChange={e => {
                    if (!readonly) {
                      onChange(e);
                      onChangeValue?.(e.target.checked);
                    }
                  }}
                />
              }
            />
          </FormGroup>
        );
      }} />
  );
}